import React from 'react';
import { Button, ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface PrimaryButtonProps extends ButtonProps {
  children: React.ReactNode;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({ className, children, ...props }) => {
  return (
    <Button
      className={cn(
        "bg-wedding-pink hover:bg-wedding-pink/90 text-white",
        className
      )}
      {...props}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
